// extracted by mini-css-extract-plugin
export default {"form":"SamGovPanel_form__oh7Ad","dropdown_label":"SamGovPanel_dropdown_label__su75f"};